// removed by extract-text-webpack-plugin
module.exports = {"White":"#FFFFFF","ScreenMDMin":"(min-width: 992px)","resetButton":"G8d21cf","arrow":"G56a6d9 G8d21cf","left":"G083c66","right":"Gd35322"};